import gql from 'graphql-tag';

import lessonFragment from '~/shared/graphql-queries/lessons/lesson-fragment';

export default gql`
  query findManyLessonQuery(
    $limit: Int = 20
    $filter: FilterFindManyLessonInput
  ) {
    findManyLessonQuery(
      filter: $filter
      skip: 0
      limit: $limit
      sort: _ID_ASC
    ) {
      ...LessonFragment
    }
  }
  ${lessonFragment}
`;
